







import { Component, Prop, Vue } from "vue-property-decorator";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

@Component({
  name: "sbSpinner",
  components: {
    PulseLoader
  }
})
export default class Spinner extends Vue {
  @Prop({ default: "12" }) private size!: string;
  @Prop({ default: "black" }) private color!: string;
}
